import { Card, CardContent } from '@mesh.ai/rabbit';

import {
  ExpandablePaper,
  ExpandablePaperBody,
  ExpandablePaperHeader,
} from 'uiToolkitV1/ExpandablePaper/ExpandablePaper';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { ReviewTypeCard } from './ReviewTypeCard';
import { TYPE_OF_REVIEWS } from './constants';

const TypeOfReview = ({
  selectedReviewType,
  setSelectedReviewType,
}: {
  selectedReviewType: string;
  setSelectedReviewType: (value: string) => void;
}) => (
  <ExpandablePaper>
    <ExpandablePaperHeader title="Type of reviews" />
    <ExpandablePaperBody>
      <Card style={{ background: '#FDFDFD' }}>
        <CardContent>
          <TextBodyMedium mb="12px" bold>
            Select the review type you would like to create{' '}
          </TextBodyMedium>
          {TYPE_OF_REVIEWS.map((reviewType, index) => {
            const { ConditionComponent } = reviewType;
            return (
              <ReviewTypeCard
                key={reviewType.heading}
                heading={reviewType.heading}
                subHeading={reviewType.subHeading}
                imgSrc={reviewType.imgSrc as unknown as string}
                radioName={reviewType.key}
                onRadioChange={() => setSelectedReviewType(reviewType.key)}
                isChecked={selectedReviewType === reviewType.key}
                ConditionComponent={!!ConditionComponent && <ConditionComponent />}
                isLastCard={index === TYPE_OF_REVIEWS.length - 1}
              />
            );
          })}
        </CardContent>
      </Card>
    </ExpandablePaperBody>
  </ExpandablePaper>
);

export { TypeOfReview };
